import { FC } from 'react';

import { IRecruiterDashboardSettings } from '../../../../../../hooks/useRecruiterDashboardSettings';
import { IRecruiterMetricModals } from '../../../hooks/useRecruiterMetricModals';
import { ChurnDetailsModal } from '../ChurnDetailsModal';
import { DropoutDetailsModal } from '../DropoutDetailsModal';
import { RatioDetailsModal } from '../RatioDetailsModal';
import { RetentionDetailsModal } from '../RetentionDetailsModal';
import { ShowRateDetailsModal } from '../ShowRateDetailsModal';

interface IRecruiterMetricModalsProps {
  modals: IRecruiterMetricModals;
  settings: IRecruiterDashboardSettings | null;
}

export const RecruiterMetricModals: FC<IRecruiterMetricModalsProps> = ({
  modals,
  settings,
}) => {
  const { activeModal, close, modalFilterProps } = modals;

  return (
    <>
      <ChurnDetailsModal
        visible={
          activeModal === 'churn-period' || activeModal === 'churn-quarterly'
        }
        onClose={close}
        variant={activeModal === 'churn-quarterly' ? 'quarterly' : 'period'}
        data={
          activeModal === 'churn-period'
            ? modals.churnPeriodData
            : modals.churnQuarterlyData
        }
        filter={modalFilterProps}
      />

      <RetentionDetailsModal
        visible={activeModal === 'retention'}
        onClose={close}
        data={modals.retentionDetailsData}
        filter={modalFilterProps}
        repeatDonationsThreshold={settings?.repeatDonationsThreshold}
        historyDataCutoff={settings?.historyDataCutoff}
      />

      <DropoutDetailsModal
        visible={activeModal === 'dropout'}
        onClose={close}
        data={modals.dropoutDetailsData}
        filter={modalFilterProps}
        historyDataCutoff={settings?.historyDataCutoff}
      />

      <RatioDetailsModal
        visible={activeModal === 'ratio'}
        onClose={close}
        data={modals.ratioDetailsData}
        filter={modalFilterProps}
        repeatDonationsThreshold={settings?.repeatDonationsThreshold}
        historyDataCutoff={settings?.historyDataCutoff}
      />

      <ShowRateDetailsModal
        visible={activeModal === 'showRate'}
        onClose={close}
        data={modals.showRateDetailsData}
        filter={modalFilterProps}
        donorDonationFrequency={settings?.donorDonationFrequency}
        donorEligibilityDays={settings?.donorEligibilityDays}
        historyDataCutoff={settings?.historyDataCutoff}
      />
    </>
  );
};
